import { graphql, useStaticQuery } from "gatsby";

export const useProgramFees = () => {
  const { fees } = useStaticQuery(graphql`
    {
      fees: wp {
        globalProgramConfig: gviConfigSettings {
          acfGenericGlobalConfig {
            ...ProgramFeesFragment
          }
        }
      }
    }
  `);

  return fees?.globalProgramConfig?.acfGenericGlobalConfig ?? {};
};
